import React from "react";
import { start } from "repl";

interface CircularCountDownProps {
  maxTime: number;
  currentTime: number;
  isWinning: boolean;
}

function polarToCartesian(centerX:number, centerY:number, radius:number, angleInDegrees:number) {
  var angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;

  return {
    x: centerX + (radius * Math.cos(angleInRadians)),
    y: centerY + (radius * Math.sin(angleInRadians))
  };
}

function describeArc(x:number, y:number, radius:number, startAngle:number, endAngle:number) {

  var start = polarToCartesian(x, y, radius, endAngle);
  var end = polarToCartesian(x, y, radius, startAngle);

  var largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";

  var d = [
    "M", start.x, start.y,
    "A", radius, radius, 0, largeArcFlag, 0, end.x, end.y
  ].join(" ");

  return d;
}

function mapNumber (number: number, in_min: number, in_max: number, out_min: number, out_max: number):number {
  return (number - in_min) * (out_max - out_min) / (in_max - in_min) + out_min;
}

interface SVGCircleProps {
  radius: number,
  strokeColor: string
}

const SVGCircle: React.FC<SVGCircleProps> = ({ radius, strokeColor}) => {
  return (
    <svg className="absolute top-0 left-0">
      <path fill="none" stroke={strokeColor} strokeWidth="6" strokeLinecap="round" d={describeArc(72, 72, 68, 10, radius)} />
    </svg>
  );
};

const CircularCountDown: React.FC<CircularCountDownProps> = ({maxTime, currentTime, isWinning}) => {

  const circleRadius = (maxTime === currentTime) ? 360 : mapNumber(maxTime - currentTime, maxTime, 0, 0, 360);
  const deltaWhite = currentTime == 0 ? 0 : 10;
  const alphaColor = isWinning ? 'rgba(57, 193, 108, 0.2)' : 'rgba(244, 67, 54, 0.2)';
  const bgColor = currentTime == 0 ? 'tranparent' : 'white';
  const color = currentTime == 0 ? 'tranparent' : isWinning ? 'rgb(57, 193, 108)' : 'rgb(244, 67, 54)';

  return (

    <div className="h-full flat-card flex flex-col gap-4 !px-4 flex-1 center">
      <div className="relative flex flex-col justify-center items-center w-[142px] h-[142px] bg-white">

        {/* Elapsed Time Circle - Alpha*/}
        <SVGCircle radius={350} strokeColor={alphaColor}/>

        {/* Background Color Circle */}
        <SVGCircle radius={Math.min(350, circleRadius + deltaWhite)} strokeColor={bgColor}/>

        {/* Current Time Circle */}
        <SVGCircle radius={Math.min(350, circleRadius + deltaWhite)} strokeColor={color}/>

        <p className={`text-3xl ${isWinning ? 'text-victory-green' : 'text-red-500'}`}>
          {currentTime}s
        </p>
        <p className="text-lg">Countdown</p>
      </div>
    </div>

  );
}

export default CircularCountDown;